import Vue from 'vue';

const solutionEventBus = new Vue();

export default solutionEventBus;